import React, { Component } from "react";
import { Document, Page, pdfjs } from "react-pdf";

import { Spin, Button, notification, Carousel, Divider } from "antd"; //Typography, Input,
// import { SearchOutlined } from "@ant-design/icons";
// import ReadMoreReact from "read-more-react";
import { history } from "../../history";
import { connect } from "react-redux";
import { ChatWidget } from "@papercups-io/chat-widget";
import { IoPersonOutline } from "react-icons/io5";
import {
  IoMdTime,
  IoIosArrowDroprightCircle,
  IoIosArrowDropleftCircle,
  IoIosCalendar,
  IoMdPaper,
  IoIosPaper,
  IoMdPlay,
  IoMdAdd,
  IoIosAddCircle,
  IoMdClose,
} from "react-icons/io";

import axiosGlobal from "../../axios-global";
import { getAPIUrl } from "../../configs/global_var";
import ModalLogin from "../../components/modalLogin/index.js";
import CardPublish from "./indexCard.js";
// import Carousel from "../../components/carousel/index.js";
import { ParsedDate } from "../../function/ParseDate";
import { changeStatus } from "../../redux/actions/auth/loginActions";
// import clock from "../../assets/img/clock.png";
// import avatar from "../../assets/img/avatar.png";
// import editGif from "../../assets/img/edit.gif";
// import layersGif from "../../assets/img/layers.gif";
import dotGrid from "../../assets/img/dotGrid.png";
// import headerBg from "../../assets/img/header-bg.png";

import "../../assets/css/publish.css";
import "../../assets/css/modal.css";

// const { Text } = Typography;
// const axios = axiosGlobal();
class Index extends Component {
  constructor(props) {
    super(props);
    // pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    this.state = {
      loading: true,
      loadingReport: true,
      data: [],
      dataNon: [],
      dataPro: [],
      modalLogin: false,
      modalApply: false,
      modalVideo: false,
      modalReport: false,
      link: "https://colagio.shratech.com/",
      srcreport: null,
      srcVideo: null,
      stopVideo: false,
      publish_id: null,
      publish: null,
      institute: null,
      carousels: [],
      numPages: null,
      pageNumber: 1,
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.fetchPublish("non-professional");
    this.fetchPublish("professional");
    changeStatus(this.props.token !== null, false);
    getAPIUrl().then((res) => {
      this.setState({ carousels: res[0].carousel });
    });
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }

  fetchPublish(x) {
    this.setState({ loading: true });
    console.log(window.location.hostname);
    axiosGlobal().then((res) => {
      res
        .post(`/landing/gpublish/get?category=${x}`, {
          domain: window.location.hostname,
        })
        .then((result) => {
          if (x === "non-professional") {
            this.setState({
              dataNon: result.data.data,
              loading: false,
            });
            console.log(this.state.dataNon);
          } else if (x === "professional") {
            this.setState({
              dataPro: result.data.data,
              loading: false,
            });
            console.log(this.state.dataPro);
          }
        })
        .catch((err) => {});
    });
  }

  closeModal = (type) => {
    if (type === "login") {
      this.setState({ modalLogin: false });
    } else if (type === "apply") {
      this.setState({ modalApply: false, stopVideo: true });
    } else if (type === "video") {
      this.setState({ srcVideo: null, modalVideo: false });
    } else if (type === "report") {
      this.setState({ modalReport: false });
    }
  };
  openModal = (data) => {
    if (!this.props.isLogin) {
      this.setState({ modalLogin: true });
    } else {
      this.setState({
        modalApply: true,
        publish: data.publish_name,
        institute: data.inst_name,
        publish_id: data.publish_id,
      });
    }
  };
  openVideoModal = async (data) => {
    await this.detailPublishByPublishId(data, "video_tutorial");
    // console.log(video);
    // console.log(data.video_url);
    // if (!this.state.srcVideo) {
    //   this.openNotification("Tidak ada video tutorial", false);
    // } else {
    //   this.setState({
    //     modalVideo: true,
    //     // srcVideo: video,
    //     stopVideo: false,
    //   });
    // }
  };

  openReportModal = async (data) => {
    await this.detailPublishByPublishId(data, "report_example");
    // if (!this.state.srcReport) {
    //   this.openNotification("Tidak ada contoh laporan", false);
    // } else {
    //   this.setState({
    //     modalReport: true,
    //     // srcReport: data.report_example,
    //   });
    // }
  };

  detailPublishByPublishId = (data, i) => {
    console.log(data, i);
    axiosGlobal().then((res) => {
      res
        .post(`/landing/publish/get?publishId=${data.publish_id}`, {
          domain: window.location.hostname,
        })
        .then((res) => {
          if (i === "video_tutorial") {
            this.setState({
              srcVideo: res.data.data[0].video_url,
              modalVideo: true,
              stopVideo: false,
            });
          } else if (i === "report_example") {
            this.setState({
              srcReport: res.data.data[0].report_example,
              modalReport: true,
            });
          }
        })
        .catch((err) => {});
    });
  };

  onDocumentLoadSuccess({ numPages }) {
    this.setState({ numPages: numPages });
    console.log(numPages);
    console.log(this.state.numPages);
  }

  apply() {
    axiosGlobal().then((axios) => {
      axios
        .post("/landing/publish/enroll", {
          token: this.props.token,
          publishId: this.state.publish_id,
        })
        .then((res) => {
          this.openNotification("Berhasil menambahkan data", true);
          setTimeout(() => {
            history.push("/ecommerce/my-application");
            window.location.reload();
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.status);
          if (err.message === "Network Error") {
            this.openNotification(
              "Gagal mengambil data, silahkan periksa koneksi Anda",
              false
            );
          } else if (err.response.status === 401) {
            this.openNotification(
              "Session Anda telah berakhir, silakan login kembali",
              false
            );
            // } else if (err.response.data.message) {
          } else {
            this.openNotification(err.response.data.message, false);
            setTimeout(() => {
              history.push("/ecommerce/my-application");
              window.location.reload();
            }, 1500);
          }
        })
        .then(() => this.setState({ loading: false }));
    });
    this.setState({ modalApply: false });
  }

  buttonClickedHandler = () => {
    this.setState({ modalLogin: !this.state.modalLogin });
  };

  openNotification = (msg, status) => {
    const args = {
      message: msg,
      duration: 3,
      className: status ? "notif-succes" : "notif-faild",
    };
    notification.open(args);
  };

  content = (color, text) => {
    const content = <p style={{ color: `${color}` }}> {text} </p>;
    return content;
  };

  render() {
    const {
      loading,
      data,
      dataNon,
      dataPro,
      modalLogin,
      modalApply,
      modalVideo,
      modalReport,
      publish,
      institute,
      srcReport,
      link,
      pageNumber,
      numPages,
    } = this.state;
    console.log(dataNon);

    return (
      <>
        {/* <Carousel /> */}
        <main style={{ backgroundColor: "#F6F6F6" }}>
          <section className="container-intro">
            <Carousel
              autoplay
              arrows
              prevArrow={<IoIosArrowDropleftCircle color="grey" />}
              nextArrow={<IoIosArrowDroprightCircle color="grey" />}
              style={{
                position: "relative",
                zIndex: 1,
                backgroundColor: "grey",
              }}
            >
              {this.state.carousels.map((carousel, seq) => (
                <img
                  src={carousel.url}
                  style={{ width: "100%" }}
                  alt=""
                  id={seq}
                />
              ))}
            </Carousel>
            {/* <h1>Integrated Online Assessment Platform</h1>
          <h5 className="subtitle-intro">
            Mengukur beragam <b>kompetensi kebekerjaan kandidat</b> hanya dengan
            satu alat ukur yang cepat, tepat dan akurat
          </h5> */}
            {/* <img src={layersGif} alt="layers" />
          <img
            src={editGif}
            style={{
              width: "60px",
              position: "absolute",
              top: "10%",
              right: "20%",
            }}
            alt="edit"
          /> */}
            <img
              src={dotGrid}
              style={{ position: "fixed", left: "17vw", bottom: "30%" }}
              alt="dot"
            />
          </section>
          <section className="container-content">
            <div className="content-publish">
              {loading ? (
                <Spin
                  className="loading"
                  style={{ marginTop: "40vh", marginBottom: "59vh" }}
                />
              ) : (
                <>
                  {dataNon.length === 0 && dataPro.length === 0 ? (
                    <div style={{ marginTop: "120px" }}>
                      <p>Tidak tersedia paket aktif</p>
                    </div>
                  ) : (
                    <>
                      {dataNon.length !== 0 && (
                        <>
                          <div
                            style={{
                              display: "inline-flex",
                              width: "80%",
                              marginTop: "24px",
                            }}
                          >
                            <Divider
                              orientation="left"
                              style={{ borderTopColor: "black" }}
                            >
                              {window.location.hostname !==
                                "ppsbidn.shratech.com" && (
                                <h5>Non Professional</h5>
                              )}
                            </Divider>
                          </div>
                          {dataNon.map((v, i) => (
                            <CardPublish
                              v={v}
                              onReport={this.openReportModal}
                              onVideo={this.openVideoModal}
                              onModal={this.openModal}
                            />
                          ))}
                        </>
                      )}
                      {dataPro.length !== 0 && (
                        <>
                          <div
                            style={{
                              display: "inline-flex",
                              width: "80%",
                              // marginTop: "24px",
                            }}
                          >
                            <Divider
                              orientation="left"
                              style={{ borderTopColor: "black" }}
                            >
                              {window.location.hostname !==
                                "ppsbidn.shratech.com" && <h5>Professional</h5>}
                            </Divider>
                          </div>
                          {dataPro.map((v, i) => (
                            // <div className="card-publish" key={i}>
                            <CardPublish
                              v={v}
                              onReport={this.openReportModal}
                              onVideo={this.openVideoModal}
                              onModal={this.openModal}
                              // key={i}
                              // onPsikogram={this.psikogram}
                              // onStart={this.start}
                              // onStartInAdvance={this.startInAdvance}
                              // onConfirmationPdf={this.confirmationPdf}
                            />
                            // </div>
                          ))}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            {/* modals */}
            <div
              className={
                modalReport
                  ? "modal-container-active column"
                  : "modal-container-inactive"
              }
              onClick={() => this.closeModal("report")}
            >
              <div
                className="modal-body lg-report"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div className="font-bold font-center font-32 font-serif container">
                  <h3 style={{ flexGrow: "11" }}>Contoh Laporan</h3>
                  <IoMdClose
                    className="close"
                    onClick={() => this.closeModal("report")}
                  />
                </div>
                {/* #toolbar=0&view=fitH */}
                {/* <p>{srcReport}</p> */}
                {/* src={`${link}${srcReport}#view=fitH`} */}
                {srcReport ? (
                  <iframe
                    width="100%"
                    height="90%"
                    src={`${link}${srcReport}`}
                    type="application/pdf"
                    title="Contoh Laporan"
                  ></iframe>
                ) : (
                  <Spin className="loading" style={{ margin: "7% 47%" }} />
                )}
                {/* <Document
                file={`${link}${srcReport}`}
                options={{ workerSrc: "/pdf.worker.js" }}
                onLoadSuccess={this.onDocumentLoadSuccess}
              >
                {Array.from(new Array(this.state.numPages), (el, index) => (
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
              </Document> */}
              </div>
            </div>

            <div
              className={
                modalVideo
                  ? "modal-container-active column"
                  : "modal-container-inactive"
              }
              onClick={() => this.closeModal("video")}
            >
              <div
                className="modal-body lg"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div className="font-bold font-center font-32 font-serif container">
                  <h3 style={{ flexGrow: "11" }}>Video Tutorial</h3>
                  <IoMdClose
                    className="close"
                    onClick={() => this.closeModal("video")}
                  />
                </div>
                {/* {this.state.stopVideo ? (
                  <iframe
                    title="Video Tutorial"
                    style={{ display: "none" }}
                  ></iframe>
                ) : ( */}
                <iframe
                  width="100%"
                  height="85%"
                  autoplay="true"
                  src={`${this.state.link}${this.state.srcVideo}?autoplay=1`}
                  title="Video Tutorial"
                  allow="autoplay; encrypted-media"
                  allowfullscreen="true"
                ></iframe>
                {/* // <video width="100%" height="85%" controls>
                  //   <source
                  //     src={`${this.state.link}${this.state.srcVideo}?autoplay=1`}
                  //     type="video/mp4"
                  //   />
                  //   {/* <iframe
                  //   src={`${this.state.link}${this.state.srcVideo}`}
                  //   title="Video Tutorial"
                  // ></iframe> */}
                {/* // </video> */}
                {/* )} */}
              </div>
            </div>

            <div
              className={
                modalApply
                  ? "modal-container-active column"
                  : "modal-container-inactive"
              }
              onClick={() => this.closeModal("apply")}
            >
              <div
                className="modal-body sm"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  style={{ marginBottom: "1rem" }}
                  className="font-bold width font-32 font-serif"
                >
                  <h3>Confirmation</h3>
                </div>
                <div className="font-center width font-24 font-serif font-space-1">
                  <h5>{`Are you sure want to apply ${publish} in ${institute}?`}</h5>
                </div>
                <div className="btn-container">
                  <Button
                    className="button-cancel"
                    style={{ margin: "4px" }}
                    onClick={() => this.closeModal("apply")}
                  >
                    <h5
                      style={{ color: "#7367f0", margin: "auto" }}
                      className="cancel"
                    >
                      Cancel
                    </h5>
                  </Button>
                  <Button
                    className="button-apply"
                    style={{ margin: "4px" }}
                    onClick={() => this.apply()}
                  >
                    <h5 style={{ color: "#fff", margin: "auto" }}>Continue</h5>
                  </Button>
                </div>
              </div>
            </div>
          </section>
          {/* modalLogin */}
          <div>
            <ModalLogin
              isOpen={modalLogin}
              buttonClicked={this.buttonClickedHandler}
              onClose={() => this.closeModal("login")}
              style={{ top: "0 !important" }}
            />
          </div>
          {/* modalLogin */}

          <ChatWidget
            accountId="a55e0d41-b47e-4283-950b-348fb6865937"
            title="Welcome to shratech"
            subtitle="Ask us anything in the chat window below 😊"
            primaryColor="#7367F0"
            greeting=""
            awayMessage=""
            newMessagePlaceholder="Start typing..."
            showAgentAvailability={false}
            agentAvailableText="We're online right now!"
            agentUnavailableText="We're away at the moment."
            requireEmailUpfront={false}
            iconVariant="outlined"
            baseUrl="https://app.papercups.io"
            // Optionally include data about your customer here to identify them
            // customer={{
            //   name: __CUSTOMER__.name,
            //   email: __CUSTOMER__.email,
            //   external_id: __CUSTOMER__.id,
            //   metadata: {
            //     plan: "premium"
            //   }
            // }}
          />
        </main>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.login.token,
  };
};

export default connect(mapStateToProps, null)(Index);
